import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withRoot = getWithRootPathGetter('/opobff/opo-platform');

export const opobffCaseApiPaths = {
  opoCases: withRoot('/cases/opo'),
  opoCaseById: withRoot('/cases/opo/:caseId'),
  opoCaseDonorData: withRoot('/cases/opo/:caseId/donor-data'),
  opoCaseActivityLogs: withRoot('/cases/opo/:caseId/activity-logs'),
  createOpoDraft: withRoot('/cases/opo/create-draft'),
  opoCaseNrpApplicabilityAndType: withRoot('/cases/opo/:caseId/clinical-data/nrp-applicability-and-type'),
  deleteOpoDraftCase: withRoot('/cases/opo/:caseId/delete-draft'),
  opoCaseContactsAssignees: withRoot('/cases/opocontacts/:caseId/assignees'),
  caseAssignees: withRoot('/cases/cases/:caseId/assignees'),
} as const;

export const getOpobffCaseApiUrl = {
  opoCases: () => opobffCaseApiPaths.opoCases,
  opoCaseById: (caseId: string) => replacePathParams(opobffCaseApiPaths.opoCaseById, { caseId }),
  opoCaseDonorData: (caseId: string) => replacePathParams(opobffCaseApiPaths.opoCaseDonorData, { caseId }),
  opoCaseActivityLogs: (caseId: string) => replacePathParams(opobffCaseApiPaths.opoCaseActivityLogs, { caseId }),
  createOpoDraft: () => opobffCaseApiPaths.createOpoDraft,
  opoCaseNrpApplicabilityAndType: (caseId: string) =>
    replacePathParams(opobffCaseApiPaths.opoCaseNrpApplicabilityAndType, { caseId }),
  deleteOpoDraftCase: (caseId: string) => replacePathParams(opobffCaseApiPaths.deleteOpoDraftCase, { caseId }),
  opoCaseContactsAssignees: (caseId: string) =>
    replacePathParams(opobffCaseApiPaths.opoCaseContactsAssignees, { caseId }),
  caseAssignees: (caseId: string) => replacePathParams(opobffCaseApiPaths.caseAssignees, { caseId }),
};
